'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Student = require('./Student');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Student).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }